<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Cabang</h5>
            </template>
            <div class="big-filter-label multi-select-filter filter-form-wrapper mb-3">
                <b-row>
                    <b-col md="12" lg="8">
                        <b-form-group class="form-inline" label-for="filterCabang" label="Cabang">
                            <multiselect
                                name="kotaCabang"
                                id="filterCabang"
                                v-model="input.filterKota" 
                                :options="kotaOption" 
                                :internal-search="false"
                                :loading="isLoading"
                                @search-change="searchKota"
                                :allow-empty="false"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="(Kota) Ketik min. 4 huruf untuk mencari"
                            />
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterNameCode" label="Kode / Nama">
                            <b-form-input
                                id="filterNameCode"
                                v-model="input.filterName" name="filterTable"
                                type="search"
                                placeholder="Kode / Nama"
                                @keyup.enter="onFilter" 
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="statusCabang" label="Status Cabang">
                            <b-form-select v-model="input.filterStatus" id="statusCabang" name="statusCabang" :options="statusOpt" value-field="value" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Status Cabang</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <div class="filter-btn-wrapper">
                            <b-button class="mr-2" variant="pgiBtn" :disabled="isBusy" name="searchTableBtn" @click="onFilter"> 
                                <i class="fa fa-search"></i>
                            </b-button>
                            <b-button variant="pgiBtn" name="reseFilterBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-button class="mb-3" variant="pgiBtn" name="cabangAddBtn" @click="inputCabang">Input Cabang</b-button>
            <b-table bordered hover show-empty
                :busy="isBusy" 
                :items="cabang"
                :fields="fields"
                :no-local-sorting="false"
                @sort-changed="sortingChanged" 
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data cabang.
                </template>
                <template v-slot:cell(cashInHand)="row">
                    <div class="text-right no-wrap" v-if="row.item.cashInHand == null">{{$helper.addThousandSeparator(row.item.cashInHand)}} </div>
                    <div class="text-right no-wrap" v-else-if="row.item.cashInHand < 0">- Rp{{$helper.addThousandSeparator(row.item.cashInHand).replace("-", "")}}</div>
                    <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.cashInHand)}} </div>
                </template>
                <template v-slot:cell(cashVirtual)="row">
                    <div class="text-right no-wrap" v-if="row.item.cashVirtual == null">{{$helper.addThousandSeparator(row.item.cashVirtual)}} </div>
                    <div class="text-right no-wrap" v-else-if="row.item.cashVirtual < 0">- Rp{{$helper.addThousandSeparator(row.item.cashVirtual).replace("-", "")}}</div>
                    <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.cashVirtual)}} </div>
                </template>
                <template v-slot:cell(kode)="row">
                    <p class="mb-0">{{row.item.kode}}</p>
                    <p class="mb-0 smallText font-bold">{{ getJenisCabangLabel(row.item) }}</p>
                    <p class="mb-0 smallText font-bold">Kelas {{row.item.branchClass}}</p>
                </template>
                <template v-slot:cell(name)="row">
                    <p class="mb-0">{{row.item.name}}</p>
                    <p class="mb-0 smallText font-bold">{{row.item.bannerName}}</p>
                    <p class="mb-0 smallText text-muted">{{row.item.kota.name}}</p>
                </template>
                <template v-slot:cell(kuCabang)="row">
                    <p class="mb-0">{{row.item.kuCabang.kuName}}</p>
                    <p class="mb-0 smallText text-muted">{{row.item.kuCabang.kuHp}}</p>
                    <p class="mb-0 smallText text-muted">{{row.item.kuCabang.kuEmail}}</p>
                </template>
                <template v-slot:cell(isActive)="row">
                    <div class="no-wrap">
                        <b-badge variant="success" v-if="row.item.isActive == true">Buka</b-badge>
                        <b-badge variant="danger" v-else>Tutup</b-badge>
                        <b-button size="sm" class="ml-2 table-button edit" v-b-tooltip.hover title="Ganti Status" name="btnEditStatus" @click="openModalEditStatus(row.item.id, row.item)">
                            <i class="fa fa-pencil-square-o"></i>
                        </b-button>
                        <p class="mb-0 smallText text-muted" v-if="row.item.closedAt != null && !row.item.isActive">Tutup pada {{$helper.changeDateFormat(row.item.closedAt)}}</p>
                        <p class="mb-0 smallText text-muted" v-if="row.item.operationalDate != null && row.item.isActive">Operasional {{$helper.changeDateFormat(row.item.operationalDate)}}</p>
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-link :to="`${$route.path}/${row.item.id}`">
                            <b-button size="sm" class="mr-3 table-button view" v-b-tooltip.hover title="Detail" name="cabangViewBtn">
                                <i class="fa fa-info"></i>
                            </b-button>
                        </b-link>
                        <b-link :to="`${$route.path}/${row.item.id}/edit`">
                            <b-button size="sm" class="table-button edit" v-b-tooltip.hover title="Edit" name="cabangEditBtn">
                                <i class="fa fa-pencil-square-o"></i>
                            </b-button>
                        </b-link>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" :options="options" @change="onLimitChange">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        <ModalConfirm id="modal-confirm-editStatus" title="Konfirmasi Ubah Status Cabang" :desc="getDescStatus(selectedRow)" @submit="onEditStatus" />
    </div>
</template>

<script>
export default {
    name: 'master-cabang',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10,
                filterKota: null,
                filterName: null,
                filterStatus: null,
                sortBy: null,
                sortDesc: null
            },

            activeId: null,
            activeIdStatus: null,
            
            fields: [
                { key: "kode", label: "Kode", sortable:true},
                { key: "name", label: "Nama", sortable:true},
                { key: "noTelp", label: "No. Telp" },
                { key: "ku.fullname", label: "KU" },
                { key: "cashInHand", label: "Cash in Hand", sortable:true},
                { key: "cashVirtual", label: "Kas Virtual", sortable:true},
                { key: "isActive", label: "Status"},
                { key: "action", label: "Aksi"},
            ],
            cabang: [],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            statusOpt: [
                {value: true, name: 'Buka'},
                {value: false, name: 'Tutup'}
            ],
            kotaOption: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            page: '',
            size: '',
            totalViewText: "",
            isLoading: false,
            loading: false,
            query: "",
            selectedRow: null,
        }
    }, 

    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        getJenisCabangLabel(item) {
            return item.isKcu ? "KCU" : "KCP"
        },

        init(){
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)

            let getCabang = this.$axios.get("cabang/"+this.query).then(response => {
      
                this.cabang = response.data.data
                this.updateTotalItem(response.data.total)
            })

            Promise.all([getCabang]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        
        //----------------- Fungsi Ambil Data Cabang -----------------

        getCabang(){
            this.toggleBusy()
            this.cabang = []

            if(this.input.filterKota != null) this.query = this.query + "&filterKabupatenKota=" + this.input.filterKota.id
            if(this.input.filterName != null) this.query = this.query + "&filterName=" + this.input.filterName
            if(this.input.filterStatus != null) this.query = this.query + "&filterIsActive=" + this.input.filterStatus
            if(this.input.sortBy != null) {
                if(this.input.sortBy == "cashInHand") this.query = this.query + "&sortBy=cashInHandBerjalan"
                else this.query = this.query + "&sortBy=" + this.input.sortBy
            }
            if(this.input.sortDesc != null) this.query = this.query + "&sortDesc=" + this.input.sortDesc
        
            this.$axios.get("cabang/"+this.query).then(response => {
                this.cabang = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        openModalEditStatus(id, row) {
            this.activeId = id
            this.selectedRow = row
            this.$bvModal.show("modal-confirm-editStatus")
        },

        onEditStatus(){
            var idx = this.cabang.findIndex(item => item.id == this.activeId )
            var cabang = this.cabang[idx]
            var status = cabang.isActive

            let payload = new FormData()
            
            //----------------- Append Data -----------------

            payload.append("cabangId", this.activeId)
            payload.append("isActive", !status)

            //----------------- Submit Semua Data -----------------

            // this.isSubmitting = true
            this.$axios.post("/cabang/change-is-active", payload).then(response => {
                cabang.isActive = !status
                this.$bvModal.hide("modal-confirm-editStatus")
                this.$helper.toastSucc(this, "Status Cabang berhasil diubah!")

            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.getCabang()
                // this.isSubmitting = false
            })
        },
           
        //----------------- Fungsi Cari Kota -----------------   

        searchKota(searchQuery){
            if(searchQuery.length >= 4){
                this.isLoading = true
                this.$axios.get('area/search/kota/?name='+searchQuery).then(response => {
                    this.kotaOption = response.data
                    this.isLoading = false
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
            }
        },


        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getCabang()
        },

        onPageChange(){
            if (this.loading == false){
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getCabang()
            }
        },

        sortingChanged(ctx) {
            if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset(){
            this.input.filterKota = null
            this.input.filterName = null
            this.input.filterStatus = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getCabang()
        },

        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getCabang()
        },        
        

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        inputCabang(){
            this.$router.push({path: `${this.$route.path}/input`});
        },

        getDescStatus(row) {
            if (!row) return '';
            
            if (row.isActive) {
                return 'Apakah anda yakin untuk mengubah status cabang menjadi "Tutup"?'
            }

            return 'Apakah anda yakin untuk mengubah status cabang menjadi "Buka"?'
        }
    },

    created(){
        this.init()
    }
}
</script>
